export default {"src":"/_next/static/media/facebook.95a17fd8.svg","height":22,"width":13,"blurWidth":0,"blurHeight":0};